<template>
  <div class="comment" >
    <div v-for="comment1 in comment" :key="comment1.id">
      <div class="info">
        <div class="avatar"></div>
        <div class="author">
          <h4>{{ comment1.author }}</h4>
          <span>{{ comment1.time }}</span>
        </div>
        <div class="likes">{{ comment1.likes }}</div>
        <div class="reply">Reply</div>
      </div>
      
      <p class="text">{{ comment1.text }}</p>

      <div v-if="replies" v-for="reply in comment1.replies" :key="reply.id" :style="{ paddingLeft: reply.depth * 15 + 'px'}">
        <div class="hide_replies">
          <div @click="replies = !replies">Hide replies</div>
        </div>
        
        <div class="info">
          <div class="avatar"></div>
          <div class="author">
            <h4>{{ reply.author }}</h4>
            <span>{{ reply.time }}</span>
          </div>
          <div class="likes">{{ reply.likes }}</div>
          <div class="reply">Reply</div>
        </div>
        <p class="text">{{ reply.text }}</p>

        <div v-for="reply1 in reply.replies" :key="reply1.id" :style="{ paddingLeft: reply1.depth*15 + 'px'}">
          <div class="info">
            <div class="avatar"></div>
            <div class="author">
              <h4>{{ reply1.author }}</h4>
              <span>{{ reply1.time }}</span>
            </div>
            <div class="likes">{{ reply1.likes }}</div>
          </div>
          <p class="text">{{ reply1.text }}</p>
        </div>
      </div>
    </div>
    
    <div v-if="!replies" class="show_replies">
      <div @click="replies = !replies">Show replies</div>
    </div>

    <label class="add_comment">
      <span class="open" @click="commentEdit = true"></span>
      <span class="sign" @click="assignActive = true"></span>
      <span class="files"></span>
      <p class="textarea" type="text" contenteditable @input="here($event)">{{ commentBody }}</p>
      <div class="button_set" v-if="commentBody != ''">
        <div class="button secondary" @click.stop="commentBody = ''">Cancel</div>
        <div class="button" @click.stop="addComment()">Send</div>
      </div>
    </label>
    <div class="attached_people" v-if="listOfAttached.length != 0">
      <div v-for="name in listOfAttached" :key="name">{{ name }} <span @click="removeName(name)"></span></div>
    </div>
    
    <div class="shadow" :class="assignActive ? 'shadow_assign' : null" v-if="commentEdit || assignActive" @click="commentEdit = false; assignActive = false"></div>
    <assign class="assign" v-if="assignActive" @cancel="cancelAssign" @nameTransition="fillNames" :listOfAttached="listOfAttached"/>
    <div class="comment_edit" v-if="commentEdit">
      <editor v-model="commentBody"
        api-key="no-api-key"
        :init="{
          menubar: false,
          plugins: 'lists link image imagetools nonbreaking paste',
          toolbar: 'undo redo | image | alignleft aligncenter alignright | bullist numlist | bold underline italic | h1 h2 h3',
          object_resizing: 'img',
          branding: false,
          file_picker_types: 'file image media',
          content_style: `@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800'); @import url('/mce_editor.css'); body { font-family: Inter; }; ol,ul { padding-left: 20px;}`,
          image_uploadtab: true,
          paste_data_images: true,
          image_advtab: true,
          imagetools_cors_hosts: ['localhost:8080'],
          imagetools_toolbar: 'rotateleft rotateright | flipv fliph | editimage imageoptions',
          content_css: '/content.css',
          importcss_append: true,
          paste_preprocess: function (pl, o) {
            o.content = smart_paste(o.content); //todo fix and use again
          },
          images_upload_handler: tinymceImageUploadHandler,
        }"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, toRefs, defineEmits } from 'vue';
import Editor from '@tinymce/tinymce-vue';
import assign from './assign.vue';
const props = defineProps({ comments: Array });
let comment = ref(props.comments);
let replies = ref(false);
let assignActive = ref(false);
let commentEdit = ref(false);
let commentBody = ref('');
let listOfAttached = ref([]);
let commentBase = ref({
  id: 4,
  author: 'Tim Apple',
  time: '00:00',
  text: '',
  replies: [],
  depth: 2,
  likes: null,
});
function cancelAssign() {
  assignActive.value = false;
};
function here(e) {
  commentBody.value = e.target.innerText;
  // console.log(e.target.innerText, 'commentBody');
};
function removeName(name) {
  let i = listOfAttached.value.indexOf(name);
  if (i !== -1) {
    listOfAttached.value.splice(i, 1);
  }
};
function fillNames(arr) {
  console.log(arr, 'arr')
  listOfAttached.value = arr;
  assignActive.value = false;
};

function tinymceImageUploadHandler(blobInfo, success, failure, progress) {
  const reader = new FileReader();
  reader.onload = function() {
    const base64String = reader.result;
    success(base64String);
  };
  reader.readAsDataURL(blobInfo.blob());
};
function addComment() {
  commentBase.value.text = commentBody.value;
  comment.value.push({ ...commentBase.value });
  commentBody.value = '';
};
</script>

<style lang="scss" scoped>
.attached_people{
  display: flex;
  flex-wrap: wrap;
  >div{
		height: 32px;
		line-height: 32px;
		margin: 5px 0px;
		border: 1px solid #006C3E;
		box-sizing: border-box;
		width: fit-content;
		padding: 0 0 0 5px;
		border-radius: 3px;
		color: #006C3E;
		background-color: rgba(0, 108, 62, 0.15);
    margin-right: 5px;
    display: flex;
    justify-content: center;
    span{
      display: inline-block;
      cursor: pointer;
      width: 24px;
      height: 30px;
      text-align: center;
      color: #787878;
      background-image: url(../../../public/img/close.svg);
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
}
.comment{
  width: 100%;
}
.shadow{
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1;
  bottom: 0px;
  top: 0px;
  left: 0px;
  right: 0px;
}
.shadow_assign{
  background-color: transparent;
}
.comment_edit{
  position: fixed;
  top: 100px;
  bottom: 100px;
  left: 100px;
  right: 100px;
  z-index: 2;
}
.info{
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  .avatar{
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-image: url(../../../public/img/avatar.png);
    background-size: contain;
    margin-right: 16px;
    @media screen and (max-width: 480px), screen and (max-height: 480px) and (orientation: landscape){
      margin-right: 8px;
    }
  }
  h4{
    font-weight: 500;
  }
  span{
    color: #bcbcbc
  }
  h4,span{
    max-height: 20px;
    line-height: 20px;
    margin: 0px;
  }
  .likes,.reply{
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    color: #787878;
    font-size: 1rem;
    
  }
  .likes{
    margin-left: auto;
    padding-left: 40px;
    background-image: url(../../../public/img/book/thumbs-up.svg);
    background-repeat: no-repeat;
    background-size: 30px;
    background-position: center left 5px;
  }
  .reply{
    margin-left: 32px;
    @media screen and (max-width: 480px), screen and (max-height: 480px) and (orientation: landscape){
      margin-left: 12px;
    }
  }
}
.text{
  margin-left: 56px;
  margin-top: 0px;
  margin-bottom: 20px;
  @media screen and (max-width: 480px), screen and (max-height: 480px) and (orientation: landscape){
    margin-bottom: 8px;
    margin-left: 48px;
  }
}
.hide_replies{
  height: 40px;
  width: 100%;
  position: relative;
  border-bottom: 1px solid rgba(37, 37, 37, 0.1);
  margin-bottom: 10px;
  div{
    position: absolute;
    right: 0px;
    color: #787878;
    line-height: 40px;
    padding-left: 40px;
    background-image: url(../../../public/img/book/hide_replies.svg);
    background-repeat: no-repeat;
    cursor: pointer;
    background-position: center left;
  }
  @media screen and (max-width: 480px), screen and (max-height: 480px) and (orientation: landscape){
    margin-top: -8px;
  }
}
.show_replies{
  display: flex;
  justify-content: center;
  color: #787878;
  line-height: 40px;
  height: 40px;
  div{
    cursor: pointer;
  }
  @media screen and (max-width: 480px), screen and (max-height: 480px) and (orientation: landscape){
    margin-top: -8px;
  }
}
.add_comment{
  display: inline-block;
  position: relative;
  margin-top: 20px;
  width: 100%;
  @media screen and (max-width: 480px), screen and (max-height: 480px) and (orientation: landscape){
    margin-top: 0;
  }
  .textarea{
    padding: calc((48px - 1.2rem)/2) 100px calc((48px - 1.2rem)/2) 60px;
    border: 1px solid #bcbcbc;
    width: 100%;
    outline: none;
    border-radius: 5px;
    font-size: 1rem;
    line-height: 1.2rem;
    box-sizing: border-box;
    color: #252525;
    resize: none;
    overflow: hidden;
    cursor: text;
    margin: 0px;
  }
  .open,.sign,.files{
    height: 40px;
    width: 40px;
    position: absolute;
    top: 4px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 35px;
    cursor: pointer
  }
  .open{
    background-image: url(../../../public/img/book/open_in_new_window.svg);
    left: 16px
  }
  .sign{
    background-image: url(../../../public/img/book/sign.svg);
    right: 58px
  }
  .files{
    background-image: url(../../../public/img/book/files.svg);
    right: 16px
  }
  .button_set{
    position: absolute;
    right: 0px;
    bottom: -100px;
    .button{
      width: 150px;
    }
    .button:first-child{
      margin-right: 10px;
    }
  }
}
</style>